import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";

import useStyles from "./travelConfirm.styles";

import { useAppSelector } from "../../app/hooks";
import moneyImg from "../../assets/imgs/exchange/money.png";
import { City } from "../../constants/const";

import { TravelTransport } from "../../constants/travel";
import { convertDateTimeSimple } from "../../utils/utils";

interface TravelConfirmPopupProps {
  travelType: string;
  travelCityId: number;
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleStartTravel: () => void;
}

const TravelConfirmPopup: React.FC<TravelConfirmPopupProps> = ({
  travelType,
  travelCityId,
  openModal,
  setOpenModal,
  handleStartTravel,
}) => {
  const { classes } = useStyles();
  const { myProfile } = useAppSelector((state) => state.profile);

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box className={classes.titleText}>Are you sure?</Box>

          <Box className={classes.locationBox}>
            <Box className={classes.locationTitle}>
              <Box>From</Box>
              <Box></Box>
              <Box>To</Box>
            </Box>
            <Box className={classes.locationDetail}>
              <Box>{myProfile.city !== undefined && City[myProfile.city]}</Box>
              <Box>
                <ArrowRightAltIcon />
              </Box>
              <Box>{City[travelCityId]}</Box>
            </Box>
          </Box>

          <Box className={classes.detailBox}>
            <Box
              component={"img"}
              className={classes.travelImg}
              src={TravelTransport[travelType].icon}
            ></Box>
            <Box className={classes.detailRight}>
              <Box className={classes.detailCol}>
                <Box>Type:</Box>
                <Box>{TravelTransport[travelType].travelType}</Box>
              </Box>
              <Box className={classes.detailCol}>
                <Box>Cost:</Box>
                <Box>
                  <Box
                    component={"img"}
                    src={moneyImg}
                    className={classes.moneyImg}
                  ></Box>
                  <Box>{TravelTransport[travelType].cost}</Box>
                </Box>
              </Box>
              <Box className={classes.detailCol}>
                <Box>Next travel:</Box>
                <Box>
                  {convertDateTimeSimple(
                    TravelTransport[travelType].travelTime
                  )}
                </Box>
              </Box>
            </Box>
          </Box>

          <Button
            variant="contained"
            className={classes.attemptBut}
            onClick={handleStartTravel}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default TravelConfirmPopup;
